import React from 'react';

function MapTrifoldIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
      <path
        d="M20.9151 2.84983C20.821 2.77649 20.7114 2.72555 20.5947 2.70088C20.478 2.6762 20.3571 2.67844 20.2414 2.70741L14.2375 4.20813L8.2121 1.19491C8.04422 1.11118 7.85191 1.09027 7.66996 1.13599L1.38424 2.70741C1.21426 2.7499 1.06336 2.84799 0.955518 2.98608C0.847678 3.12417 0.789089 3.29435 0.789062 3.46956V17.6124C0.789081 17.7318 0.816306 17.8496 0.868672 17.9569C0.921037 18.0642 0.997166 18.1582 1.09127 18.2316C1.18538 18.3051 1.295 18.3562 1.41179 18.3809C1.52858 18.4057 1.64949 18.4035 1.76531 18.3746L7.76915 16.8738L13.7946 19.8871C13.904 19.941 14.0243 19.9692 14.1462 19.9696C14.2104 19.9695 14.2744 19.9616 14.3367 19.946L20.6225 18.3746C20.7924 18.3321 20.9433 18.234 21.0512 18.0959C21.159 17.9578 21.2176 17.7876 21.2176 17.6124V3.46956C21.2177 3.35006 21.1904 3.23212 21.138 3.12473C21.0856 3.01734 21.0094 2.92332 20.9151 2.84983ZM8.64621 3.16902L13.3605 5.52616V17.913L8.64621 15.5558V3.16902ZM2.36049 4.0834L7.07478 2.90483V15.4271L2.36049 16.6057V4.0834ZM19.6462 16.9986L14.9319 18.1771V5.65483L19.6462 4.47625V16.9986Z"
        fill="url(#paint0_linear_15072_59031)"
        stroke="url(#paint1_linear_15072_59031)"
        strokeWidth="0.279365"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15072_59031"
          x1="11.0033"
          y1="1.1123"
          x2="11.0033"
          y2="19.9696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15072_59031"
          x1="11.0033"
          y1="1.1123"
          x2="11.0033"
          y2="19.9696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function ListBulletsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
      <path
        d="M5.2846 2.25572C5.2846 2.04734 5.36738 1.84749 5.51473 1.70014C5.66208 1.55279 5.86193 1.47001 6.07031 1.47001H18.6417C18.8501 1.47001 19.05 1.55279 19.1973 1.70014C19.3447 1.84749 19.4275 2.04734 19.4275 2.25572C19.4275 2.4641 19.3447 2.66395 19.1973 2.8113C19.05 2.95865 18.8501 3.04143 18.6417 3.04143H6.07031C5.86193 3.04143 5.66208 2.95865 5.51473 2.8113C5.36738 2.66395 5.2846 2.4641 5.2846 2.25572ZM18.6417 7.75572H6.07031C5.86193 7.75572 5.66208 7.8385 5.51473 7.98585C5.36738 8.1332 5.2846 8.33305 5.2846 8.54143C5.2846 8.74982 5.36738 8.94967 5.51473 9.09702C5.66208 9.24437 5.86193 9.32715 6.07031 9.32715H18.6417C18.8501 9.32715 19.05 9.24437 19.1973 9.09702C19.3447 8.94967 19.4275 8.74982 19.4275 8.54143C19.4275 8.33305 19.3447 8.1332 19.1973 7.98585C19.05 7.8385 18.8501 7.75572 18.6417 7.75572ZM18.6417 14.0414H6.07031C5.86193 14.0414 5.66208 14.1242 5.51473 14.2716C5.36738 14.4189 5.2846 14.6188 5.2846 14.8271C5.2846 15.0355 5.36738 15.2354 5.51473 15.3827C5.66208 15.5301 5.86193 15.6129 6.07031 15.6129H18.6417C18.8501 15.6129 19.05 15.5301 19.1973 15.3827C19.3447 15.2354 19.4275 15.0355 19.4275 14.8271C19.4275 14.6188 19.3447 14.4189 19.1973 14.2716C19.05 14.1242 18.8501 14.0414 18.6417 14.0414ZM1.74888 1.07715C1.51579 1.07715 1.28792 1.14627 1.09411 1.27577C0.90029 1.40528 0.74923 1.58934 0.660026 1.8047C0.570823 2.02006 0.547484 2.25703 0.592959 2.48565C0.638434 2.71427 0.750682 2.92427 0.915509 3.0891C1.08033 3.25392 1.29034 3.36617 1.51896 3.41165C1.74758 3.45712 1.98455 3.43378 2.1999 3.34458C2.41526 3.25537 2.59933 3.10431 2.72883 2.9105C2.85833 2.71668 2.92746 2.48882 2.92746 2.25572C2.92746 1.94314 2.80329 1.64337 2.58226 1.42234C2.36124 1.20132 2.06146 1.07715 1.74888 1.07715ZM1.74888 7.36286C1.51579 7.36286 1.28792 7.43198 1.09411 7.56149C0.90029 7.69099 0.74923 7.87506 0.660026 8.09041C0.570823 8.30577 0.547484 8.54274 0.592959 8.77136C0.638434 8.99998 0.750682 9.20998 0.915509 9.37481C1.08033 9.53964 1.29034 9.65188 1.51896 9.69736C1.74758 9.74284 1.98455 9.7195 2.1999 9.63029C2.41526 9.54109 2.59933 9.39003 2.72883 9.19621C2.85833 9.0024 2.92746 8.77453 2.92746 8.54143C2.92746 8.22886 2.80329 7.92908 2.58226 7.70806C2.36124 7.48703 2.06146 7.36286 1.74888 7.36286ZM1.74888 13.6486C1.51579 13.6486 1.28792 13.7177 1.09411 13.8472C0.90029 13.9767 0.74923 14.1608 0.660026 14.3761C0.570823 14.5915 0.547484 14.8285 0.592959 15.0571C0.638434 15.2857 0.750682 15.4957 0.915509 15.6605C1.08033 15.8254 1.29034 15.9376 1.51896 15.9831C1.74758 16.0286 1.98455 16.0052 2.1999 15.916C2.41526 15.8268 2.59933 15.6757 2.72883 15.4819C2.85833 15.2881 2.92746 15.0602 2.92746 14.8271C2.92746 14.5146 2.80329 14.2148 2.58226 13.9938C2.36124 13.7727 2.06146 13.6486 1.74888 13.6486Z"
        fill="url(#paint0_linear_15072_63185)"
        stroke="url(#paint1_linear_15072_63185)"
        strokeWidth="0.266667"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15072_63185"
          x1="9.99888"
          y1="1.07715"
          x2="9.99888"
          y2="16.0057"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15072_63185"
          x1="9.99888"
          y1="1.07715"
          x2="9.99888"
          y2="16.0057"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function NotePencilIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path
        d="M19.9833 3.69947L16.8405 0.556611C16.7675 0.483558 16.6809 0.425605 16.5855 0.386064C16.4901 0.346524 16.3879 0.326172 16.2846 0.326172C16.1813 0.326172 16.0791 0.346524 15.9837 0.386064C15.8883 0.425605 15.8017 0.483558 15.7287 0.556611L6.30013 9.98518C6.22719 10.0582 6.16935 10.1449 6.12992 10.2403C6.09049 10.3356 6.07023 10.4379 6.07031 10.5411V13.6839C6.07031 13.8923 6.15309 14.0922 6.30044 14.2395C6.44779 14.3869 6.64764 14.4696 6.85603 14.4696H9.99888C10.1021 14.4697 10.2043 14.4495 10.2997 14.41C10.3951 14.3706 10.4818 14.3128 10.5548 14.2398L19.9833 4.81125C20.0564 4.73828 20.1144 4.65163 20.1539 4.55624C20.1934 4.46086 20.2138 4.35862 20.2138 4.25536C20.2138 4.15211 20.1934 4.04986 20.1539 3.95448C20.1144 3.8591 20.0564 3.77244 19.9833 3.69947ZM9.67379 12.8982H7.64174V10.8662L13.9275 4.58045L15.9595 6.6125L9.67379 12.8982ZM17.0703 5.5017L15.0383 3.46965L16.2846 2.22331L18.3167 4.25536L17.0703 5.5017ZM19.4275 10.5411V18.3982C19.4275 18.815 19.2619 19.2147 18.9672 19.5094C18.6725 19.8041 18.2728 19.9696 17.856 19.9696H2.14174C1.72497 19.9696 1.32527 19.8041 1.03057 19.5094C0.735873 19.2147 0.570313 18.815 0.570312 18.3982V2.68393C0.570312 2.26716 0.735873 1.86746 1.03057 1.57276C1.32527 1.27806 1.72497 1.1125 2.14174 1.1125H9.99888C10.2073 1.1125 10.4071 1.19528 10.5545 1.34263C10.7018 1.48998 10.7846 1.68983 10.7846 1.89822C10.7846 2.1066 10.7018 2.30645 10.5545 2.4538C10.4071 2.60115 10.2073 2.68393 9.99888 2.68393H2.14174V18.3982H17.856V10.5411C17.856 10.3327 17.9388 10.1328 18.0862 9.98549C18.2335 9.83814 18.4334 9.75536 18.6417 9.75536C18.8501 9.75536 19.05 9.83814 19.1973 9.98549C19.3447 10.1328 19.4275 10.3327 19.4275 10.5411Z"
        fill="url(#paint0_linear_15072_58767)"
        stroke="url(#paint1_linear_15072_58767)"
        strokeWidth="0.4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15072_58767"
          x1="10.392"
          y1="0.326172"
          x2="10.392"
          y2="19.9696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15072_58767"
          x1="10.392"
          y1="0.326172"
          x2="10.392"
          y2="19.9696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function HouseLineIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none">
      <path
        d="M23.0045 18.3979H21.433V11.3264L21.6629 11.5562C21.8106 11.7037 22.0108 11.7864 22.2194 11.7862C22.4281 11.786 22.6282 11.703 22.7756 11.5553C22.9231 11.4076 23.0058 11.2074 23.0056 10.9987C23.0054 10.79 22.9223 10.5899 22.7746 10.4425L13.1153 0.786069C12.8206 0.491591 12.4211 0.326172 12.0045 0.326172C11.5879 0.326172 11.1883 0.491591 10.8937 0.786069L1.23429 10.4425C1.08698 10.5899 1.00428 10.7898 1.00437 10.9982C1.00447 11.2067 1.08734 11.4065 1.23478 11.5538C1.38221 11.7011 1.58212 11.7838 1.79053 11.7837C1.99893 11.7836 2.19877 11.7007 2.34607 11.5533L2.57589 11.3264V18.3979H1.00446C0.79608 18.3979 0.59623 18.4806 0.44888 18.628C0.30153 18.7753 0.21875 18.9752 0.21875 19.1836C0.21875 19.392 0.30153 19.5918 0.44888 19.7392C0.59623 19.8865 0.79608 19.9693 1.00446 19.9693H23.0045C23.2128 19.9693 23.4127 19.8865 23.5601 19.7392C23.7074 19.5918 23.7902 19.392 23.7902 19.1836C23.7902 18.9752 23.7074 18.7753 23.5601 18.628C23.4127 18.4806 23.2128 18.3979 23.0045 18.3979ZM4.14732 9.755L12.0045 1.89785L19.8616 9.755V18.3979H15.1473V12.8979C15.1473 12.6895 15.0645 12.4896 14.9172 12.3423C14.7698 12.1949 14.57 12.1121 14.3616 12.1121H9.64732C9.43894 12.1121 9.23909 12.1949 9.09174 12.3423C8.94439 12.4896 8.86161 12.6895 8.86161 12.8979V18.3979H4.14732V9.755ZM13.5759 18.3979H10.433V13.6836H13.5759V18.3979Z"
        fill="url(#paint0_linear_15072_14616)"
        stroke="url(#paint1_linear_15072_14616)"
        strokeWidth="0.266667"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15072_14616"
          x1="12.0045"
          y1="0.326172"
          x2="12.0045"
          y2="19.9693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15072_14616"
          x1="12.0045"
          y1="0.326172"
          x2="12.0045"
          y2="19.9693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function MapPinSimpleAreaIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none">
      <path
        d="M11.2143 8.10589V15.2559C11.2143 15.4643 11.2971 15.6641 11.4444 15.8115C11.5918 15.9588 11.7916 16.0416 12 16.0416C12.2084 16.0416 12.4082 15.9588 12.5556 15.8115C12.7029 15.6641 12.7857 15.4643 12.7857 15.2559V8.10589C13.7396 7.91118 14.5872 7.36922 15.1642 6.58507C15.7412 5.80093 16.0065 4.83047 15.9087 3.86184C15.8108 2.89321 15.3568 1.99542 14.6346 1.34252C13.9124 0.689617 12.9736 0.328125 12 0.328125C11.0264 0.328125 10.0876 0.689617 9.36538 1.34252C8.6432 1.99542 8.18917 2.89321 8.09132 3.86184C7.99347 4.83047 8.25877 5.80093 8.83577 6.58507C9.41278 7.36922 10.2604 7.91118 11.2143 8.10589ZM12 1.89875C12.4662 1.89875 12.9219 2.037 13.3096 2.296C13.6972 2.55501 13.9993 2.92314 14.1777 3.35386C14.3561 3.78457 14.4028 4.25851 14.3119 4.71575C14.2209 5.17299 13.9964 5.59299 13.6668 5.92265C13.3371 6.2523 12.9171 6.47679 12.4599 6.56775C12.0026 6.6587 11.5287 6.61202 11.098 6.43361C10.6672 6.2552 10.2991 5.95308 10.0401 5.56545C9.7811 5.17782 9.64286 4.72209 9.64286 4.25589C9.64286 3.63074 9.8912 3.03119 10.3332 2.58914C10.7753 2.14709 11.3748 1.89875 12 1.89875ZM23 15.2559C23 18.3182 17.3321 19.9702 12 19.9702C6.66795 19.9702 1 18.3182 1 15.2559C1 14.4957 1.3742 13.3771 3.16071 12.3674C4.36482 11.6858 6.02071 11.1623 7.95062 10.8529C8.05271 10.8368 8.15697 10.841 8.25745 10.8651C8.35794 10.8893 8.45268 10.933 8.53626 10.9938C8.61985 11.0546 8.69064 11.1313 8.7446 11.2194C8.79856 11.3076 8.83464 11.4055 8.85076 11.5075C8.86688 11.6096 8.86274 11.7139 8.83857 11.8144C8.81439 11.9149 8.77067 12.0096 8.70988 12.0932C8.6491 12.1768 8.57245 12.2476 8.4843 12.3015C8.39616 12.3555 8.29825 12.3916 8.19616 12.4077C6.47348 12.6846 4.95509 13.1571 3.9317 13.7385C3.06741 14.2246 2.57143 14.7786 2.57143 15.2559C2.57143 16.568 6.15821 18.3988 12 18.3988C17.8418 18.3988 21.4286 16.568 21.4286 15.2559C21.4286 14.7786 20.9326 14.2246 20.0683 13.7346C19.041 13.1531 17.5265 12.6807 15.8038 12.4038C15.6996 12.3901 15.5991 12.3557 15.5084 12.3026C15.4177 12.2494 15.3386 12.1786 15.2757 12.0943C15.2129 12.01 15.1676 11.914 15.1425 11.8119C15.1175 11.7098 15.1132 11.6037 15.1299 11.4999C15.1466 11.3961 15.1839 11.2967 15.2397 11.2076C15.2956 11.1185 15.3687 11.0415 15.4548 10.9811C15.5409 10.9208 15.6382 10.8784 15.7411 10.8564C15.8439 10.8343 15.95 10.8332 16.0533 10.8529C17.9832 11.1623 19.6391 11.6858 20.8432 12.3674C22.6258 13.3771 23 14.4957 23 15.2559Z"
        fill="url(#paint0_linear_15072_39746)"
        stroke="url(#paint1_linear_15072_39746)"
        strokeWidth="0.4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15072_39746"
          x1="12"
          y1="0.328125"
          x2="12"
          y2="19.9702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15072_39746"
          x1="12"
          y1="0.328125"
          x2="12"
          y2="19.9702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function MusicNotesIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
      <path
        d="M20.3404 0.70695C20.2462 0.633613 20.1367 0.582675 20.0199 0.558C19.9032 0.533325 19.7824 0.535562 19.6666 0.56454L7.09518 3.7074C6.9252 3.74989 6.7743 3.84797 6.66646 3.98606C6.55862 4.12415 6.50003 4.29433 6.5 4.46954V15.281C5.84455 14.843 5.06155 14.6367 4.2754 14.6947C3.48925 14.7528 2.74503 15.0719 2.161 15.6013C1.57697 16.1307 1.18662 16.8402 1.05197 17.6169C0.917317 18.3936 1.04609 19.193 1.41782 19.8882C1.78955 20.5833 2.38293 21.1343 3.10367 21.4536C3.82441 21.7728 4.63118 21.8421 5.39579 21.6504C6.16041 21.4586 6.83901 21.0168 7.32379 20.3952C7.80857 19.7736 8.07172 19.0078 8.07143 18.2195V9.79766L19.0714 7.04766V12.1381C18.416 11.7002 17.633 11.4938 16.8468 11.5519C16.0607 11.6099 15.3165 11.929 14.7324 12.4584C14.1484 12.9879 13.758 13.6973 13.6234 14.474C13.4887 15.2507 13.6175 16.0502 13.9892 16.7453C14.361 17.4405 14.9544 17.9914 15.6751 18.3107C16.3958 18.63 17.2026 18.6993 17.9672 18.5075C18.7318 18.3157 19.4104 17.874 19.8952 17.2524C20.38 16.6308 20.6432 15.865 20.6429 15.0767V1.32668C20.6429 1.20718 20.6157 1.08925 20.5632 0.981855C20.5108 0.874464 20.4346 0.780444 20.3404 0.70695ZM4.53572 20.1838C4.14722 20.1838 3.76745 20.0686 3.44442 19.8528C3.1214 19.6369 2.86963 19.3302 2.72096 18.9712C2.57228 18.6123 2.53338 18.2174 2.60918 17.8363C2.68497 17.4553 2.87205 17.1053 3.14676 16.8306C3.42147 16.5559 3.77147 16.3688 4.15251 16.293C4.53354 16.2172 4.92849 16.2561 5.28742 16.4048C5.64634 16.5534 5.95312 16.8052 6.16896 17.1282C6.3848 17.4513 6.5 17.831 6.5 18.2195C6.5 18.7405 6.29305 19.2401 5.92468 19.6085C5.5563 19.9769 5.05668 20.1838 4.53572 20.1838ZM8.07143 8.17713V5.08338L19.0714 2.33338V5.42713L8.07143 8.17713ZM17.1071 17.041C16.7186 17.041 16.3389 16.9258 16.0158 16.7099C15.6928 16.4941 15.4411 16.1873 15.2924 15.8284C15.1437 15.4695 15.1048 15.0745 15.1806 14.6935C15.2564 14.3124 15.4435 13.9624 15.7182 13.6877C15.9929 13.413 16.3429 13.2259 16.7239 13.1501C17.105 13.0743 17.4999 13.1132 17.8588 13.2619C18.2178 13.4106 18.5246 13.6624 18.7404 13.9854C18.9562 14.3084 19.0714 14.6882 19.0714 15.0767C19.0714 15.5976 18.8645 16.0973 18.4961 16.4656C18.1277 16.834 17.6281 17.041 17.1071 17.041Z"
        fill="url(#paint0_linear_15072_9410)"
        stroke="url(#paint1_linear_15072_9410)"
        strokeWidth="0.4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15072_9410"
          x1="10.8214"
          y1="0.541016"
          x2="10.8214"
          y2="21.7566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15072_9410"
          x1="10.8214"
          y1="0.541016"
          x2="10.8214"
          y2="21.7566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function ShareIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none">
      <path
        d="M20.9878 6.73992L16.2735 11.4542C16.1261 11.6016 15.9261 11.6845 15.7176 11.6845C15.5091 11.6845 15.3092 11.6016 15.1617 11.4542C15.0143 11.3068 14.9315 11.1068 14.9315 10.8983C14.9315 10.6898 15.0143 10.4899 15.1617 10.3424L18.5354 6.96974H14.6373C12.7208 6.96921 10.8585 7.60569 9.34318 8.77909C7.8279 9.95249 6.7456 11.5962 6.26647 13.4519C6.21438 13.6538 6.08422 13.8267 5.90464 13.9326C5.72506 14.0385 5.51076 14.0687 5.30888 14.0166C5.10701 13.9645 4.9341 13.8344 4.82819 13.6548C4.72229 13.4752 4.69206 13.2609 4.74415 13.059C5.30949 10.8654 6.58838 8.9222 8.37945 7.53529C10.1705 6.14838 12.372 5.3966 14.6373 5.39832H18.5374L15.1617 2.02564C15.0887 1.95264 15.0308 1.86597 14.9913 1.77059C14.9518 1.67521 14.9315 1.57298 14.9315 1.46974C14.9315 1.36651 14.9518 1.26428 14.9913 1.1689C15.0308 1.07352 15.0887 0.986853 15.1617 0.913852C15.3092 0.76642 15.5091 0.683594 15.7176 0.683594C15.8209 0.683594 15.9231 0.703928 16.0185 0.743436C16.1139 0.782944 16.2005 0.840851 16.2735 0.913852L20.9878 5.62814C21.0609 5.70111 21.1188 5.78776 21.1584 5.88315C21.1979 5.97853 21.2183 6.08078 21.2183 6.18403C21.2183 6.28729 21.1979 6.38953 21.1584 6.48491C21.1188 6.5803 21.0609 6.66695 20.9878 6.73992ZM17.2891 16.3983H2.36049V4.6126C2.36049 4.40422 2.27771 4.20437 2.13036 4.05702C1.98301 3.90967 1.78316 3.82689 1.57478 3.82689C1.36639 3.82689 1.16654 3.90967 1.01919 4.05702C0.871843 4.20437 0.789063 4.40422 0.789062 4.6126V17.184C0.789063 17.3924 0.871843 17.5923 1.01919 17.7396C1.16654 17.887 1.36639 17.9697 1.57478 17.9697H17.2891C17.4974 17.9697 17.6973 17.887 17.8446 17.7396C17.992 17.5923 18.0748 17.3924 18.0748 17.184C18.0748 16.9756 17.992 16.7758 17.8446 16.6284C17.6973 16.4811 17.4974 16.3983 17.2891 16.3983Z"
        fill="url(#paint0_linear_15072_9561)"
        stroke="url(#paint1_linear_15072_9561)"
        strokeWidth="0.4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15072_9561"
          x1="11.0037"
          y1="0.683594"
          x2="11.0037"
          y2="17.9697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15072_9561"
          x1="11.0037"
          y1="0.683594"
          x2="11.0037"
          y2="17.9697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D2E" />
          <stop offset="1" stopColor="#FF9698" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function LeftDotsPattern() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="100" viewBox="0 0 63 100" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 91.541C6.43313 91.541 8 93.1089 8 95.0404C8 96.9731 6.43313 98.541 4.5 98.541C2.56687 98.541 1 96.9731 1 95.0404C1 93.1089 2.56687 91.541 4.5 91.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 73.541C6.43313 73.541 8 75.1089 8 77.0404C8 78.9731 6.43313 80.541 4.5 80.541C2.56687 80.541 1 78.9731 1 77.0404C1 75.1089 2.56687 73.541 4.5 73.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 55.541C6.43313 55.541 8 57.1089 8 59.0404C8 60.9731 6.43313 62.541 4.5 62.541C2.56687 62.541 1 60.9731 1 59.0404C1 57.1089 2.56687 55.541 4.5 55.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 37.541C6.43313 37.541 8 39.1076 8 41.0404C8 42.9731 6.43313 44.541 4.5 44.541C2.56687 44.541 1 42.9731 1 41.0404C1 39.1076 2.56687 37.541 4.5 37.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 19.541C6.43313 19.541 8 21.1079 8 23.041C8 24.9741 6.43313 26.541 4.5 26.541C2.56687 26.541 1 24.9741 1 23.041C1 21.1079 2.56687 19.541 4.5 19.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 1.54102C6.43313 1.54102 8 3.10788 8 5.04102C8 6.97415 6.43313 8.54102 4.5 8.54102C2.56687 8.54102 1 6.97415 1 5.04102C1 3.10788 2.56687 1.54102 4.5 1.54102Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 91.541C24.4331 91.541 26 93.1089 26 95.0404C26 96.9731 24.4331 98.541 22.5 98.541C20.5669 98.541 19 96.9731 19 95.0404C19 93.1089 20.5669 91.541 22.5 91.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 73.541C24.4331 73.541 26 75.1089 26 77.0404C26 78.9731 24.4331 80.541 22.5 80.541C20.5669 80.541 19 78.9731 19 77.0404C19 75.1089 20.5669 73.541 22.5 73.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 55.541C24.4331 55.541 26 57.1089 26 59.0404C26 60.9731 24.4331 62.541 22.5 62.541C20.5669 62.541 19 60.9731 19 59.0404C19 57.1089 20.5669 55.541 22.5 55.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 37.541C24.4331 37.541 26 39.1076 26 41.0404C26 42.9731 24.4331 44.541 22.5 44.541C20.5669 44.541 19 42.9731 19 41.0404C19 39.1076 20.5669 37.541 22.5 37.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 19.541C24.4331 19.541 26 21.1079 26 23.041C26 24.9741 24.4331 26.541 22.5 26.541C20.5669 26.541 19 24.9741 19 23.041C19 21.1079 20.5669 19.541 22.5 19.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 1.54102C24.4331 1.54102 26 3.10788 26 5.04102C26 6.97415 24.4331 8.54102 22.5 8.54102C20.5669 8.54102 19 6.97415 19 5.04102C19 3.10788 20.5669 1.54102 22.5 1.54102Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5 91.541C42.4331 91.541 44 93.1089 44 95.0404C44 96.9731 42.4331 98.541 40.5 98.541C38.5669 98.541 37 96.9731 37 95.0404C37 93.1089 38.5669 91.541 40.5 91.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5 73.541C42.4331 73.541 44 75.1089 44 77.0404C44 78.9731 42.4331 80.541 40.5 80.541C38.5669 80.541 37 78.9731 37 77.0404C37 75.1089 38.5669 73.541 40.5 73.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5 55.541C42.4331 55.541 44 57.1089 44 59.0404C44 60.9731 42.4331 62.541 40.5 62.541C38.5669 62.541 37 60.9731 37 59.0404C37 57.1089 38.5669 55.541 40.5 55.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5 37.541C42.4331 37.541 44 39.1076 44 41.0404C44 42.9731 42.4331 44.541 40.5 44.541C38.5669 44.541 37 42.9731 37 41.0404C37 39.1076 38.5669 37.541 40.5 37.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5 19.541C42.4331 19.541 44 21.1079 44 23.041C44 24.9741 42.4331 26.541 40.5 26.541C38.5669 26.541 37 24.9741 37 23.041C37 21.1079 38.5669 19.541 40.5 19.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5 1.54102C42.4331 1.54102 44 3.10788 44 5.04102C44 6.97415 42.4331 8.54102 40.5 8.54102C38.5669 8.54102 37 6.97415 37 5.04102C37 3.10788 38.5669 1.54102 40.5 1.54102Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5 91.541C60.4331 91.541 62 93.1089 62 95.0404C62 96.9731 60.4331 98.541 58.5 98.541C56.5669 98.541 55 96.9731 55 95.0404C55 93.1089 56.5669 91.541 58.5 91.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5 73.541C60.4331 73.541 62 75.1089 62 77.0404C62 78.9731 60.4331 80.541 58.5 80.541C56.5669 80.541 55 78.9731 55 77.0404C55 75.1089 56.5669 73.541 58.5 73.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5 55.541C60.4331 55.541 62 57.1089 62 59.0404C62 60.9731 60.4331 62.541 58.5 62.541C56.5669 62.541 55 60.9731 55 59.0404C55 57.1089 56.5669 55.541 58.5 55.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5 37.541C60.4331 37.541 62 39.1076 62 41.0404C62 42.9731 60.4331 44.541 58.5 44.541C56.5669 44.541 55 42.9731 55 41.0404C55 39.1076 56.5669 37.541 58.5 37.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5 19.541C60.4331 19.541 62 21.1079 62 23.041C62 24.9741 60.4331 26.541 58.5 26.541C56.5669 26.541 55 24.9741 55 23.041C55 21.1079 56.5669 19.541 58.5 19.541Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5 1.54102C60.4331 1.54102 62 3.10788 62 5.04102C62 6.97415 60.4331 8.54102 58.5 8.54102C56.5669 8.54102 55 6.97415 55 5.04102C55 3.10788 56.5669 1.54102 58.5 1.54102Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
    </svg>
  );
}

function RightDotsPattern() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="82" viewBox="0 0 45 82" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5.04102C8 6.97415 6.43211 8.54102 4.50066 8.54102C2.56789 8.54102 1 6.97415 1 5.04102C1 3.10788 2.56789 1.54102 4.50066 1.54102C6.43211 1.54102 8 3.10788 8 5.04102Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 5.04102C26 6.97415 24.4321 8.54102 22.5007 8.54102C20.5679 8.54102 19 6.97415 19 5.04102C19 3.10788 20.5679 1.54102 22.5007 1.54102C24.4321 1.54102 26 3.10788 26 5.04102Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 5.04102C44 6.97415 42.4321 8.54102 40.5007 8.54102C38.5679 8.54102 37 6.97415 37 5.04102C37 3.10788 38.5679 1.54102 40.5007 1.54102C42.4321 1.54102 44 3.10788 44 5.04102Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 23.041C8 24.9741 6.43211 26.541 4.50066 26.541C2.56789 26.541 1 24.9741 1 23.041C1 21.1079 2.56789 19.541 4.50066 19.541C6.43211 19.541 8 21.1079 8 23.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 23.041C26 24.9741 24.4321 26.541 22.5007 26.541C20.5679 26.541 19 24.9741 19 23.041C19 21.1079 20.5679 19.541 22.5007 19.541C24.4321 19.541 26 21.1079 26 23.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 23.041C44 24.9741 42.4321 26.541 40.5007 26.541C38.5679 26.541 37 24.9741 37 23.041C37 21.1079 38.5679 19.541 40.5007 19.541C42.4321 19.541 44 21.1079 44 23.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 41.041C8 42.9741 6.43211 44.541 4.50066 44.541C2.56789 44.541 1 42.9741 1 41.041C1 39.1079 2.56789 37.541 4.50066 37.541C6.43211 37.541 8 39.1079 8 41.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 41.041C26 42.9741 24.4321 44.541 22.5007 44.541C20.5679 44.541 19 42.9741 19 41.041C19 39.1079 20.5679 37.541 22.5007 37.541C24.4321 37.541 26 39.1079 26 41.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 41.041C44 42.9741 42.4321 44.541 40.5007 44.541C38.5679 44.541 37 42.9741 37 41.041C37 39.1079 38.5679 37.541 40.5007 37.541C42.4321 37.541 44 39.1079 44 41.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 59.041C8 60.9741 6.43211 62.541 4.50066 62.541C2.56789 62.541 1 60.9741 1 59.041C1 57.1079 2.56789 55.541 4.50066 55.541C6.43211 55.541 8 57.1079 8 59.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 59.041C26 60.9741 24.4321 62.541 22.5007 62.541C20.5679 62.541 19 60.9741 19 59.041C19 57.1079 20.5679 55.541 22.5007 55.541C24.4321 55.541 26 57.1079 26 59.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 59.041C44 60.9741 42.4321 62.541 40.5007 62.541C38.5679 62.541 37 60.9741 37 59.041C37 57.1079 38.5679 55.541 40.5007 55.541C42.4321 55.541 44 57.1079 44 59.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 77.041C8 78.9741 6.43211 80.541 4.50066 80.541C2.56789 80.541 1 78.9741 1 77.041C1 75.1079 2.56789 73.541 4.50066 73.541C6.43211 73.541 8 75.1079 8 77.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 77.041C26 78.9741 24.4321 80.541 22.5007 80.541C20.5679 80.541 19 78.9741 19 77.041C19 75.1079 20.5679 73.541 22.5007 73.541C24.4321 73.541 26 75.1079 26 77.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 77.041C44 78.9741 42.4321 80.541 40.5007 80.541C38.5679 80.541 37 78.9741 37 77.041C37 75.1079 38.5679 73.541 40.5007 73.541C42.4321 73.541 44 75.1079 44 77.041Z"
        stroke="#FF2D2E"
        strokeWidth="1.4"
      />
    </svg>
  );
}

export {
  HouseLineIcon,
  LeftDotsPattern,
  ListBulletsIcon,
  MapPinSimpleAreaIcon,
  MapTrifoldIcon,
  MusicNotesIcon,
  NotePencilIcon,
  RightDotsPattern,
  ShareIcon,
};
